import {
    Link
} from 'react-router-dom';
import logo from "../assets/img/logo.png"

export default function LampContainer ({
    tilte,
    subtitle
}) {
    const contactUs = () => {
        window.open("https://t.me/haimakefu88", "_blank")
    }
    return (
        <div>
            <header className="max-w-6xl mx-auto flex justify-between items-center md:mb-7 flex-wrap">
                <div className="flex items-center gap-4 flex-1">
                    <div className="w-14 h-14 rounded-xl flex items-center justify-center font-bold">
                        <img className="w-14 h-14" src={logo} alt="logo" />
                    </div>
                    <div >
                        <h1 className="text-xl font-bold">{tilte}</h1>
                        <div className="text-[#eaf5ff]/60 text-sm">{subtitle}</div>
                    </div>
                </div>
                <nav className="hidden md:flex gap-6 text-sky-200/80">
                    <Link to="/">海马软件</Link>
                    <Link to="/aichat">AI客服</Link>
                    <Link to="/chatpage">即时通讯</Link>
                    <Link to="/smartMonitor">智能监控</Link>
                </nav>
                <nav className="flex gap-2 ml-6">
                    <button className="px-4 py-2 rounded-lg bg-gradient-to-r from-[#00d4ff] to-[#7b61ff] text-[#021126] font-semibold" onClick={contactUs}>联系我们</button>
                </nav>
            </header>
            <nav className="flex md:hidden gap-6 mb-4 mt-3 text-sky-200/80">
                <Link to="/">海马软件</Link>
                <Link to="/aichat">AI客服</Link>
                <Link to="/chatpage">即时通讯</Link>
                <Link to="/smartMonitor">智能监控</Link>
            </nav></div>
    );
};